const postQuestions = {
  toastrTrue: 'Grupo adicionado',
  toastrFalse: 'Questão adicionada',
  txt: 'foi atualizada com sucesso'
};

export default postQuestions;
